module.exports = __webpack_public_path__ + "img/LOGO SEPLAG - BRANCO VAZADO.ec5821a1.svg";